import { styled } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';
import { ThemeMode } from 'src/frontend-common/style/theme';
import { selectUser } from 'src/redux/slices/userSlice';
import { isAdmin } from 'src/utils/user';

const ThemeSwitchButton: React.FC<{ themeName: ThemeMode; setThemeName: React.Dispatch<React.SetStateAction<ThemeMode>> }> = ({ themeName, setThemeName }) => {
  const user = useSelector(selectUser);
  const showButton = isAdmin(user);
  if (!showButton) {
    return null;
  }
  return (
    <ThemeSwapButton onClick={() => setThemeName((prev) => (prev === 'light' ? 'dark' : 'light'))} light={themeName === 'light' ? 'true' : undefined}>
      <span>T</span>
    </ThemeSwapButton>
  );
};

export default ThemeSwitchButton;

const ThemeSwapButton = styled('button')<{ light?: 'true' }>(({ light }) => ({
  position: 'absolute',
  top: '10px',
  right: '10px',
  width: '25px',
  height: '25px',
  borderRadius: '50%',
  zIndex: '100000000',
  backgroundColor: light !== 'true' ? 'black' : 'white',
  color: light === 'true' ? 'black' : 'white',
  border: `1px solid ${light === 'true' ? 'black' : 'white'}`,
  '&:hover': {
    cursor: 'pointer',
  },
}));
